import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  imports: [
    FormsModule,
    NgIf
  ],
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() searchCompact = false;
  @Input() placeholderText = 'Search by title, description, tags, sources, tables...';
  public searchQuery = '';

  public timerAfterSearchScrollToReports?: any;
  public timerWhileSearching?: any;

  constructor(private getSetData: GetSetDataService, private router: Router) {
  }

  ngOnInit() {
    this.getSetData.EmitterSearch.subscribe((data: any) => {
      this.searchQuery = this.getSetData.globalSearchQuery;
      this.updateURLWithSearchQuery();
    });

    // Gets Search parameter from URL.
    const url = new URL(window.location.href);
    const startURLSearchQuery = url.searchParams.get('search');

    if (startURLSearchQuery) {
      this.searchQuery = startURLSearchQuery;

      this.getSetData.EmitterDataFetched.subscribe((result: any) => {
        this.getSetData.emitSearchQuery(this.searchQuery);
      });
    }


    // Focus on Input for Desktop.
    if (window.innerWidth > 1100) {
      const inputElement: any = document.getElementsByClassName('js-main-search')[0];

      inputElement.focus();
    }
  }

  public scrollToReports() {
    if (this.searchCompact) {
      this.getSetData.scrollToElement('.component-report-main');
    }
  }

  emitSearchQuery(redirectBackToReports?: boolean) {

    // Navigate back to reports view if user is in blog view.
    if (location.pathname.indexOf('/blog/') > -1 && redirectBackToReports) {
      this.router.navigateByUrl('/');
    }

    clearTimeout(this.timerWhileSearching);

    // Delay search for 500ms to update URL without issues.
    this.timerWhileSearching = setTimeout(() => {
      // Updates url with search query.
      this.updateURLWithSearchQuery();

      this.getSetData.emitSearchQuery(this.searchQuery);
    }, 500);

    clearTimeout(this.timerAfterSearchScrollToReports);

    // If middle search is visible.

    if (document.body.className.indexOf('top-search-visible') === -1) {
      this.timerAfterSearchScrollToReports = setTimeout(() => {
        this.getSetData.scrollToElement('.component-report-main');

        const inputTopSearchElement: any = document.getElementsByClassName('js-main-search')[1];
        inputTopSearchElement.focus();

      }, 1000);
    }
  }

  /**
   * Updates the URL with the search query.
   */
  public updateURLWithSearchQuery() {
    // Update
    if (this.searchQuery) {
      window.history.replaceState('', '', location.origin + location.pathname + '?search=' + this.searchQuery);
    } else {
      window.history.replaceState('', '', location.origin + location.pathname);
    }
  }

  public resetSearchQuery() {
    this.searchQuery = '';
    this.emitSearchQuery();
  }
}
